import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

@NgModule({
	// eslint-disable-next-line
	imports: [CommonModule],
	declarations: [],
	exports: []
})
export class PdfComponentsModule {
	public static forRoot(): ModuleWithProviders<PdfComponentsModule> {
		return {
			ngModule: PdfComponentsModule,
			providers: []
		};
	}
}
